"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSearchSummary = exports.formatAppointmentForCrm = exports.parseCrmProvider = exports.isProviderReferred = exports.assertEventType = void 0;
/**
 * Function that asserts that a given event matches one of the included types.
 * Throws an error if the event type does not match.
 * @param {TE} event an event or object returned from an event
 * @param {...TType} eventTypes list of acceptable event types
 *
 */
function assertEventType(event, ...eventTypes) {
    if (!eventTypes.includes(event.type)) {
        throw new Error(`Invalid event: expected one of ["${eventTypes.join('", "')}"], got "${event.type}"`);
    }
}
exports.assertEventType = assertEventType;
const isProviderReferred = (referableProvider, referrals) => {
    return (referrals.findIndex(({ provider, location }) => provider.id === referableProvider.provider.id &&
        (location === null || location === void 0 ? void 0 : location.id) === referableProvider.location.id) !== -1);
};
exports.isProviderReferred = isProviderReferred;
const isProvider = (provider) => {
    return typeof provider.name !== 'string';
};
const parseSpecialties = (provider) => {
    var _a;
    return ((_a = provider.specialties) === null || _a === void 0 ? void 0 : _a.length)
        ? provider.specialties
            .map((sp) => {
            const subspecialties = sp.subspecialty || sp.subspecialties
                ? ` > ${getSubspecialties(sp)}`
                : '';
            return `${sp.name || sp.specialty}${subspecialties}`;
        })
            .join(', ')
        : '';
};
const getSubspecialties = (specialties) => {
    var _a;
    //V-8
    if (specialties.subspecialty) {
        return specialties.subspecialty;
    }
    //V-9
    return ((_a = specialties.subspecialties) === null || _a === void 0 ? void 0 : _a.length)
        ? specialties.subspecialties
            .map((subSp) => {
            return `${subSp.name}`;
        })
            .join('; ')
        : '';
};
const parseNetworks = (provider) => {
    var _a;
    return ((_a = provider.networks) === null || _a === void 0 ? void 0 : _a.length)
        ? provider.networks
            .map((nw) => (typeof nw === 'string' ? nw : nw.network))
            .join(', ')
        : '';
};
const parseCrmProvider = (provider) => {
    if (isProvider(provider)) {
        // provider is of type Provider
        const formattedSpecialties = parseSpecialties(provider);
        const formattedNetworks = parseNetworks(provider);
        return {
            id: provider.id.toString(),
            name: provider.name,
            fullname: provider.name.full || provider.name.full_name,
            specialties: provider.specialties,
            formattedSpecialties,
            networks: provider.networks,
            formattedNetworks,
            npi: provider.npi
        };
    }
    else {
        // provider is of type ProviderContent
        throw new Error(`Provider ${provider.id} is in an unexpected format`);
    }
};
exports.parseCrmProvider = parseCrmProvider;
const parseApptNotes = (appt) => {
    var _a;
    const notes = (_a = appt.notes) !== null && _a !== void 0 ? _a : appt.reason;
    if (!notes)
        return '';
    const notesArray = notes.split(',');
    return notesArray.length >= 2
        ? notesArray[1].replace('::', '').trim()
        : notesArray[0];
};
const parsePatientRelationship = ({ patient_relationship }) => (patient_relationship === 'new' ? 'New Patient' : 'Established Patient');
const formatAppointmentForCrm = ({ appointment, location, provider }) => {
    const { name, street1, street2, suite, city, state, zip, phone, fax } = location;
    return {
        durationMinutes: appointment.duration_minutes,
        startDateTime: appointment.start_datetime,
        description: parseApptNotes(appointment),
        patientRelationship: parsePatientRelationship(appointment),
        apptReason: appointment.appointment_reason,
        provider: (0, exports.parseCrmProvider)(provider),
        location: {
            name,
            street1,
            street2,
            suite,
            city,
            state,
            zip,
            phone,
            fax
        }
    };
};
exports.formatAppointmentForCrm = formatAppointmentForCrm;
const parseSearchSummary = (searchSummary) => {
    if (!searchSummary) {
        return '';
    }
    /** Search summary field is added to Referral and Appointment pages within the CRM.
     * Currently sending all the required information in following format - label 1: "Value1", label 2: "['Value 21', 'Value22']"...
     */
    const { location, filter, search_type, search_description } = searchSummary;
    const searchSummaryForCrm = [];
    if (location) {
        searchSummaryForCrm.push(`location_filter: ${JSON.stringify(location)}`);
    }
    if (filter) {
        searchSummaryForCrm.push(`filters: ${JSON.stringify(filter)}`);
    }
    if (search_type) {
        searchSummaryForCrm.push(`search_type: ${JSON.stringify(search_type)}`);
    }
    if (search_description) {
        searchSummaryForCrm.push(`search_term: ${JSON.stringify(search_description)}`);
    }
    return searchSummaryForCrm.length > 0 ? searchSummaryForCrm.join(', ') : '';
};
exports.parseSearchSummary = parseSearchSummary;
//# sourceMappingURL=util.js.map